/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { useLabel } from '@/wpt-lib/pdf/useData';

const ShortCourseDelivery = ({
    lookupSubject,
    teachingShortCourseType,
    deliveryShortCourseIndustryPartner,
    teachingDeliveryOtherType,
}: Partial<{
    lookupSubject: string;
    teachingShortCourseType: string;
    deliveryShortCourseIndustryPartner: string;
    teachingDeliveryOtherType: string;
}>) => (
    <>
        <Row widths={[50, 50]}>
            <ValueCell single label="Short Course" value={lookupSubject} />
            <ValueCell
                label="Short Course Type"
                value={useLabel('teachingShortCourseType', teachingShortCourseType ?? '')}
            />
        </Row>
        {deliveryShortCourseIndustryPartner && (
            <Row>
                <ValueCell label="Industry Partner" value={deliveryShortCourseIndustryPartner} />
            </Row>
        )}
        {teachingDeliveryOtherType && (
            <Row>
                <ValueCell label="Other Delivery Type" value={teachingDeliveryOtherType} />
            </Row>
        )}
    </>
);

export default ShortCourseDelivery;
